import { observer } from "mobx-react";
import FontBody1 from "../../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../components/fonts/font-props";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import "./refund-calculator-drawer-header.scss";
import RefundCalculatorStore from "../../../stores/refund-calculator-store";
import useDashboardTranslation from "../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IRefundCalculatorDrawerHeaderProps {
    calculatorStore: RefundCalculatorStore;
}

const RefundCalculatorDrawerHeader: React.FC<IRefundCalculatorDrawerHeaderProps> = observer(({calculatorStore}) => {
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-returns-rma-card';

    return (
        <div className="refund-caculator-drawer-header">
            <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{calculatorStore.isItemsLevelRefund ? getTranslation('ITEMS_LEVEL_REFUND', pageScope) : getTranslation('ORDER_LEVEL_REFUND',pageScope)}</FontBody1>
            { !!calculatorStore.rmaId &&
                <FontBody2 color={FONT_COLOR.NEUTRAL3}>RMA {calculatorStore.rmaId}</FontBody2>
            }
        </div>
    );
});

export default RefundCalculatorDrawerHeader;
